import { useState } from "react";
import { useTranslation } from "react-i18next";
import Slider from "react-slick";

export default function SliderDefault(props) {
  const { t } = useTranslation("common");
  const [showLeft, setShowLeft] = useState(false);
  const [showRight, setShowRight] = useState(true);
  const properties = {
    dots: false,
    arrows: true,
    slidesToShow: 6,
    centerMode: false,
    infinite: false,
    slidesToScroll: 6,
    beforeChange: (oldIndex, newIndex) => {
      if (newIndex + 6 == props.data.length) {
        setShowRight(false);
      } else {
        setShowRight(true);
      }
      if (newIndex < 1) {
        setShowLeft(false);
      } else {
        setShowLeft(true);
      }
    },
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          arrows: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3.5,
          initialSlide: 1,
          arrows: false,
          swipe: true,
          swipeToSlide: true,
          infinite: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 4,
          initialSlide: 1,
          arrows: false,
          swipe: true,
          swipeToSlide: true,
          infinite: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 1,
          arrows: false,
          swipe: true,
          swipeToSlide: true,
          infinite: true,
        },
      },
    ],
  };
  return (
    <div className={"container relative "}>
      <div className={" text-center"}>
        <h2
          className={"font-bold text-[28px] pt-[24px] md:pt-[30px] catamaran"}
        >
          {t("main.partners_title")}
        </h2>
      </div>

      {showRight && (
        <div
          className="absolute h-full w-72 hidden md:flex bg-gradient-to-l from-white right-0 top-0 z-10 max-w-md"
          style={{ width: "18rem !important" }}
        ></div>
      )}

      {showLeft && (
        <div
          className="absolute h-full w-72 hidden md:flex bg-gradient-to-r from-white left-0 top-0 z-10 max-w-md"
          style={{ width: "18rem !important" }}
        ></div>
      )}
      <Slider {...properties}>
        {props.data.map((v, i) => {
          return (
            <a href={v.link} className={"px-1"} key={i}>
              <img src={v.image} className={v.customClass} />
            </a>
          );
        })}
      </Slider>
    </div>
  );
}
